<template>
    <div>
        <div v-if="(desabilitado || salvamentoEmAndamentoOuErro) && !propsLeilao">
            <v-tooltip v-if="mostrarTextoQuandoDesabilitado" top :nudge-top="posicaoTooltip" left :nudge-left="posicaoHorizontalTooltip" :max-width="larguraTooltip">
                <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="btn-disabled" disabled depressed v-bind="$attrs" :outlined="outlined">
                            <v-icon v-if="!esconderIcone && iconeEsquerdo" :size="tamanhoIcone" class="mr-1">{{icone}}</v-icon>
                            <span :class="{'text-capitalize':textCapitalize}">{{textoBotao}}</span>
                            <v-icon v-if="!esconderIcone && !iconeEsquerdo" :size="tamanhoIcone" class="ml-1">{{icone}}</v-icon>
                        </v-btn>
                </template>
                {{retornaTextoTooltip}}
            </v-tooltip>
            <div v-else class="btn-disabled">
                <v-btn disabled depressed v-bind="$attrs" :outlined="outlined">
                    <v-icon v-if="!esconderIcone && iconeEsquerdo" :size="tamanhoIcone" class="mr-5">
                        {{ icone }}
                    </v-icon>
                    <span :class="{'text-capitalize':textCapitalize}">{{ textoBotao }}</span>
                    <v-icon v-if="!esconderIcone && !iconeEsquerdo" :size="tamanhoIcone" class="ml-3">
                        {{ icone }}
                    </v-icon>
                </v-btn>
            </div>
        </div>

        <div v-if="(desabilitado || salvamentoEmAndamentoOuErro)" class="pr-15">
            <v-tooltip v-if="mostrarTextoQuandoDesabilitado" right :nudge-right="posicaoTooltip" left :nudge-left="posicaoHorizontalTooltip" :max-width="larguraTooltip">
                <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="btn-disabled" disabled depressed v-bind="$attrs" :outlined="outlined">
                            <v-icon v-if="!esconderIcone && iconeEsquerdo" :size="tamanhoIcone" class="mr-5">
                                {{ icone }}
                            </v-icon>
                            <span :class="{'text-capitalize':textCapitalize}">{{ textoBotao }}</span>
                            <v-icon v-if="!esconderIcone && !iconeEsquerdo" :size="tamanhoIcone" class="ml-3">
                                {{ icone }}
                            </v-icon>
                        </v-btn>
                </template>
                {{retornaTextoTooltip}}
            </v-tooltip>
            <div v-else class="btn-disabled">
                <v-btn disabled depressed v-bind="$attrs" :outlined="outlined">
                    <v-icon v-if="!esconderIcone && iconeEsquerdo" :size="tamanhoIcone" class="mr-5">
                        {{ icone }}
                    </v-icon>
                    <span :class="{'text-capitalize':textCapitalize}">{{ textoBotao }}</span>
                    <v-icon v-if="!esconderIcone && !iconeEsquerdo" :size="tamanhoIcone" class="ml-3">
                        {{ icone }}
                    </v-icon>
                </v-btn>
            </div>
        </div>

        <v-btn v-if="!(desabilitado || salvamentoEmAndamentoOuErro)" color="primary" depressed v-on="$listeners" v-bind="$attrs" :outlined="outlined">
            <v-icon v-if="!esconderIcone && iconeEsquerdo" :size="tamanhoIcone" class="mr-1">{{ icone }}</v-icon>
            <span :class="{'text-capitalize':textCapitalize}">{{ textoBotao }}</span>
            <v-icon v-if="!esconderIcone && !iconeEsquerdo" :size="tamanhoIcone" class="ml-1">{{ icone }}</v-icon>
        </v-btn>

    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'BotaoPrimario',
        data () {
            return {
                tooltipMensagemBloqueioSalvamento: 'O salvamento automático deve ter sido concluído para continuar.'
            }
        },
        props: {
            mostrarTextoQuandoDesabilitado: {
                type: Boolean,
                default: true,
                required: false
            },
            textCapitalize: {
                type: Boolean,
                default: false
            },
            textoBotao: {
                type: String,
                default: 'Continuar'
            },
            desabilitado: {
                type: Boolean,
                default: false
            },
            esconderIcone: {
                type: Boolean,
                default: false
            },
            iconeEsquerdo: {
                type: Boolean,
                default: false
            },
            icone: {
                type: String,
                default: 'fas fa-arrow-right'
            },
            tamanhoIcone: {
                type: String,
                default: '15'
            },
            textoTooltip: {
                type: String,
                default: 'É necessário que todos os campos obrigatórios sejam preenchidos para continuar.'
            },
            posicaoTooltip: {
                type: String,
                default: '30'
            },
            larguraTooltip: {
                type: String,
                default: '200'
            },
            outlined: {
                type: Boolean,
                default: false
            },
            posicaoHorizontalTooltip: {
                type: String,
                default: '0'
            }
        },
        computed:{
            ...mapState({
                salvamentoAutomaticoEmAndamento: state => state.loki.autoSave.saving,
                salvamentoAutomaticoComErro: state => state.isSalvamentoAutomaticoErro
            }),
            salvamentoEmAndamentoOuErro() {
                return !!(this.salvamentoAutomaticoEmAndamento || this.salvamentoAutomaticoComErro)
            },
            retornaTextoTooltip() {
                if (this.salvamentoEmAndamentoOuErro) return this.tooltipMensagemBloqueioSalvamento
                return this.textoTooltip
            }
        }
    }
</script>

<style lang="stylus" scoped>

</style>
